export default __webpack_public_path__ + "static/media/dougs.9cc183cf.svg";